import { SORT_TYPE } from 'records/BaseList';

export const periodFields = {
    PERIOD_ID: 'periodId',
    PERIOD_NAME: 'periodName',
    START_DATE: 'startDate',
    END_DATE: 'endDate',
}

export const sortProps = [
    { id: 0, field: periodFields.PERIOD_NAME, order: SORT_TYPE.ASC, description: 'Name, Ascending', label: 'name(asc)' },
    { id: 1, field: periodFields.PERIOD_NAME, order: SORT_TYPE.DESC, description: 'Name, Descending', label: 'name(desc)' },
    { id: 2, field: periodFields.START_DATE, order: SORT_TYPE.ASC, description: 'Date, Ascending', label: 'date(asc)' },
    { id: 3, field: periodFields.START_DATE, order: SORT_TYPE.DESC, description: 'Date, Descending', label: 'date(desc)' },
];
export const defaultSortId = 3;

export const inputDateFormat = 'YYYY-MM-DD';
export const displayDateFormat = 'MMMM D, YYYY';

export const deleteConfirmationMessage = 'Are you sure you wish to delete this sales period? All sales associated with this period will be lost';
export const deleteErrorCause = 'deleting this sales period';
export const updateErrorCause = 'updating this sales period';
export const PERIOD_NAME_LENGTH_ERROR_MESSAGE = 'Period name should not be more than 300 characters';

// no data messages
export const NO_MENU_ITEMS = 'This menu does not contain any menu items. Please add items to this menu prior to adding any sales information';
export const NO_MENU_ITEMS_CALCULATOR = 'This menu does not contain any menu items. Please add items to this menu';
export const NO_SALES_PERIODS_DESCRIPTIVE = 'No Sales Periods exist for this Menu. Please';
export const NO_SALES_PERIODS_CONCISE = 'No Sales Periods Available. Lets start adding';
export const NO_SALES_VOLUME_DATA = 'To explore alternate sales and pricing levels, start by providing sales history for the sales period';
